'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = require('./remote/auth');

var Auth = {
    postConfirmPassword: function postConfirmPassword(params) {
        return _auth.AuthRemote.postConfirmPassword(params);
    },
    postForgotPassword: function postForgotPassword(params) {
        return _auth.AuthRemote.postForgotPassword(params);
    },
    postUpdatePassword: function postUpdatePassword(params) {
        return _auth.AuthRemote.postUpdatePassword(params);
    }
};

exports.default = Auth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/auth.js
// module id = AGZl
// module chunks = 46